import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BasicModalComponent } from "./basic-modal/basic-modal.component";
import { InputModule } from "../input/input.module";
import { DialogService, DynamicDialogModule } from "primeng/dynamicdialog";
import { GridConfigModalComponent } from "./grid-config-modal/grid-config-modal.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RedistributionModalComponent } from "./redistribution-modal/redistribution-modal.component";
import { CalendarModule } from "primeng/calendar";
import { TooltipModule } from "primeng/tooltip";
import { TutorialVideoModalComponent } from "./tutorial-video-modal/tutorial-video-modal.component";
import { PostModalComponent } from "./post-modal/post-modal.component";
import { DropdownModule } from "primeng/dropdown";
import { CheckboxModule } from "primeng/checkbox";
import { WidgetEditModalComponent } from "./widget-edit-modal/widget-edit-modal.component";
import { DDModule } from "../dropdown/dropdown.module";
import { ChkModule } from "../checkbox/checkbox.module";
import { DropdownGenericModule } from "../dropdown-generic/dropdown-generic.module";
import { RichTextEditorComponent } from "../rich-text-editor/rich-text-editor.component";
import { AdminReviewWidgetInfoModalComponent } from "./admin-review-widget-info-modal/admin-review-widget-info-modal.component";
import { PipesModule } from "../../pipes/pipes.module";

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    InputModule,
    CalendarModule,
    DynamicDialogModule,
    TooltipModule,
    RichTextEditorComponent,
    DropdownModule,
    CheckboxModule,
    DDModule,
    ChkModule,
    DropdownGenericModule,
    PipesModule,
  ],
  declarations: [
    BasicModalComponent,
    GridConfigModalComponent,
    RedistributionModalComponent,
    TutorialVideoModalComponent,
    PostModalComponent,
    WidgetEditModalComponent,
    AdminReviewWidgetInfoModalComponent,
  ],
  exports: [
    BasicModalComponent,
    GridConfigModalComponent,
    RedistributionModalComponent,
    TutorialVideoModalComponent,
    PostModalComponent,
    WidgetEditModalComponent,
    AdminReviewWidgetInfoModalComponent,
    DynamicDialogModule,
  ],
  providers: [DialogService],
})
export class ModalModule {}
